import React from 'react'
import { ArrowLeft, Search, Home } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation()
  return (
    <section className="relative min-h-[100dvh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-[#0a0a0f]"></div>
        <div className="absolute top-1/4 left-1/4 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-purple-600/20 rounded-full blur-[100px] sm:blur-[120px]"></div>
        <div className="absolute bottom-0 right-1/4 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-purple-500/10 rounded-full blur-[120px] sm:blur-[150px]"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] sm:w-[800px] h-[600px] sm:h-[800px] bg-purple-500/20 rounded-full blur-[80px] sm:blur-[100px]"></div>
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:3rem_3rem] sm:bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-lg mx-auto text-center">
        <div className="inline-flex items-center justify-center w-24 h-24 sm:w-32 sm:h-32 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md mb-8">
          <Search className="w-12 h-12 sm:w-16 sm:h-16 text-purple-400" strokeWidth={1.5} />
        </div>

        <h1 className="text-7xl sm:text-9xl font-black tracking-tight text-white mb-4">
          404
        </h1>
        
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
          {t('notFound.title', 'Page Not Found')}
        </h2>
        
        <p className="text-base sm:text-lg text-gray-400 max-w-md mx-auto leading-relaxed mb-10">
          {t('notFound.description', "The page you're looking for doesn't exist or has been moved.")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-purple-500 text-white font-bold rounded-xl hover:bg-purple-600 transition-all"
          >
            <Home className="w-5 h-5" />
            <span>{t('notFound.goHome', 'Go Home')}</span>
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/5 border border-white/10 rounded-xl text-white hover:bg-white/10 hover:border-white/20 transition-all font-medium"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>{t('notFound.goBack', 'Go Back')}</span>
          </button>
        </div>
      </div>
    </section>
  )
}